import CancelIcon from '@mui/icons-material/Cancel';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import React, { useCallback, useMemo } from 'react';

import IconCopyPassword from '../../../assets/images/icon-copy-password.svg';
import useCopyClipboard from '../../../hooks/useCopyClipboard';
import { IOneLink, OneLinkStatusEnum } from '../../../types/oneLink';

interface IProps {
  anchorEl: HTMLElement | null;
  menuPosition?: { top: number; left: number } | null;
  selectedItem: IOneLink | null;
  onClose: () => void;
  onDeactivate: () => void;
}

export const OneLinkContextMenu = ({ anchorEl, menuPosition, selectedItem, onClose, onDeactivate }: IProps) => {
  const { setCopied } = useCopyClipboard({ successDuration: 1000, toastDuration: 1000 });

  const handleContextMenu = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      onClose();
    },
    [onClose],
  );

  const handleCopyShippingUrl = useCallback(() => {
    setCopied(selectedItem?.url || '', 'Shipping URL');
    onClose();
  }, [onClose, selectedItem, setCopied]);

  const handleCopyPassword = useCallback(() => {
    setCopied(selectedItem?.password || '', 'Password');
    onClose();
  }, [onClose, selectedItem, setCopied]);

  const handleDeactivateClick = useCallback(() => {
    onDeactivate();
    onClose();
  }, [onClose, onDeactivate]);

  const hasPassword = useMemo(() => {
    return selectedItem?.password;
  }, [selectedItem]);

  return (
    <Menu
      anchorEl={anchorEl}
      open={!!(anchorEl || menuPosition)}
      onClose={onClose}
      onContextMenu={handleContextMenu}
      anchorReference={menuPosition ? 'anchorPosition' : 'anchorEl'}
      anchorPosition={menuPosition || undefined}
      autoFocus={false}
      disableAutoFocus={true}
      disableEnforceFocus={true}
      disableRestoreFocus={true}
    >
      <MenuItem onClick={handleCopyShippingUrl}>
        <ListItemIcon>
          <FileCopyIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Copy URL</ListItemText>
      </MenuItem>
      {hasPassword && (
        <MenuItem onClick={handleCopyPassword}>
          <ListItemIcon>
            <img src={IconCopyPassword} alt="Copy Password" style={{ width: 20, height: 20 }} />
          </ListItemIcon>
          <ListItemText>Copy Password</ListItemText>
        </MenuItem>
      )}
      {selectedItem && selectedItem?.status === OneLinkStatusEnum.Active && (
        <MenuItem onClick={handleDeactivateClick}>
          <ListItemIcon>
            <CancelIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Deactivate</ListItemText>
        </MenuItem>
      )}
    </Menu>
  );
};
